export class BreadcrumbModel {
    caption: string;
    link: string;
    municipalitySpecificCaption: boolean;
}
